import { Grid } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import DashboardInsightsContent from '../../features/dashboard-insights/DashboardInsightsContent';

const DashboardInsightsPage = () => {
  const { projectId } = useParams();

  return (
    <DashboardLayout projectId={projectId}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <DashboardInsightsContent />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default DashboardInsightsPage;